import React, { useState, useContext } from "react";
import { Button, Input } from "reactstrap";
import Cookies from "universal-cookie";

import MainContext from "../../../../context/mainContext";

import "./SettingsAccountOverview.css";

const SettingsAccountOverview = ({ user }) => {
  const [editMode, toggleEditMode] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("********");
  const [phoneNumber, setPhoneNumber] = useState("");

  const mainContext = useContext(MainContext);

  const handleSave = async () => {
    const cookies = new Cookies();
    const authToken = cookies.get("authToken");

    if (
      firstName !== user.firstName ||
      lastName !== user.lastName ||
      phoneNumber !== user.phoneNumber
    ) {
      const userObject = {
        firstName,
        lastName,
        phoneNumber,
      };

      const resp = await mainContext.updateUser(userObject, authToken);

      if (resp === 200) {
        await mainContext.fetchUserInfo(user.username, authToken);
      }
    }

    toggleEditMode(!editMode);
  };

  const inputStyle = {
    width: "557px",
    height: "25px",
    color: "#616161",
    borderLeft: "0px",
    borderTop: "0px",
    borderRight: "0px",
    borderRadius: "0px",
    boxShadow: "none",
  };

  return (
    <div className="settings-overview">
      <div className="settings-overview-toprow">
        <div className="settings-overview-title">Account Overview</div>
        {!editMode && (
          <div
            className="settings-overview-edit"
            onClick={() => {
              setFirstName(user.firstName);
              setLastName(user.lastName);
              setPhoneNumber(user.phoneNumber);
              toggleEditMode(!editMode);
            }}
          >
            Edit
          </div>
        )}
      </div>
      <div className="settings-overview-info">
        <div className="settings-overview-info-left">
          <div className="settings-overview-left-text">First Name</div>
          <div className="settings-overview-left-text">Last Name</div>
          <div className="settings-overview-left-text">Password</div>
          <div className="settings-overview-left-text">Phone</div>
        </div>
        {!editMode ? (
          <div className="settings-overview-info-right">
            <div className="settings-overview-right-text">{user.firstName}</div>
            <div className="settings-overview-right-text">{user.lastName}</div>
            <div className="settings-overview-right-text">{password}</div>
            <div className="settings-overview-right-text">{user.phoneNumber}</div>
          </div>
        ) : (
          <div className="settings-overview-info-right">
            <Input
              style={inputStyle}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <Input
              style={inputStyle}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <Input
              style={inputStyle}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Input
              style={inputStyle}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>
        )}
      </div>
      {editMode && (
        <Button
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "220px",
            height: "43px",
            marginTop: "80px",
            backgroundColor: "#3d77ff",
            borderWidth: "0px",
            boxShadow: "none",
            borderRadius: "10px",
          }}
          onClick={handleSave}
        >
          Save
        </Button>
      )}
    </div>
  );
};

export default SettingsAccountOverview;
